import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const GamesContext = createContext(null);

export function GamesProvider({ children }) {
  const [games, setGames] = useState([]);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/games");
      setGames(data);
    } catch (e) {
      setGames([]);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => {
    const byKey = new Map(games.map((g) => [g.key, g]));
    const activeGames = games.filter((g) => g.is_active !== false);
    return {
      games,
      activeGames,
      ready,
      refresh,
      labelOf: (key) => byKey.get(key)?.label || key,
      shortOf: (key) => byKey.get(key)?.short_code || (key || "").slice(0, 3).toUpperCase(),
      heroOf: (key) => byKey.get(key)?.hero_image || "",
      taglineOf: (key) => byKey.get(key)?.tagline || "",
      has: (key) => byKey.has(key),
    };
  }, [games, ready, refresh]);

  return <GamesContext.Provider value={value}>{children}</GamesContext.Provider>;
}

export function useGames() {
  const ctx = useContext(GamesContext);
  if (!ctx) throw new Error("useGames must be used inside <GamesProvider>");
  return ctx;
}
